import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';

import { Button, Card, CardContent, CardHeader, Divider, InputAdornment, TextField, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

import { useEffect } from 'react';
import updateParamsBudgetUseCase from 'tasks/services/detail/updateParamsBudgetUseCase';
import CardTextChat from './CardTextChat';
import PhotoGalleryCard from './PhotoGalleryCard';
import TestsDialog from 'tickets/components/TestsDialog';

const useStyles = makeStyles(theme => ({
    title: {
        paddingBottom: theme.spacing(1)
    },
    block: {
        paddingBottom: theme.spacing(2)
    },
    columns: {
        paddingRight: theme.spacing(1)
    },
    chip: {
        height: '60px'
    },
    greenButton: {
        backgroundColor: '#4caf50',
        color: 'white',
        '&:hover': {
            backgroundColor: '#449d48'
        }
    },
    docButton: {
        height: 50,
        fontSize: '0.75rem',
        lineHeight: 1.2,
        padding: '4px 10px',
    },
    emailButton: {
        backgroundColor: '#d93025',
        color: 'white',
        '&:hover': {
            backgroundColor: '#b1271d'
        }
    },
    copyButton: {
        backgroundColor: '#555',
        color: 'white',
        '&:hover': {
            backgroundColor: '#444'
        }
    },
    divider: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    paper: {
        padding: theme.spacing(1),
        margin: theme.spacing(1)
    },
    divObs: {
        height: '400px',
        overflow: 'scroll',
        backgroundColor: '#eeeeee',
        border: '1px solid lightgrey'
    },
    contentCardObs: {

    },
    message: {
        display: 'flex',
        backgroundColor: 'white',
        alignItems: 'center',
        margin: '5px',
        padding: '5px',
        paddingLeft: '10px',
        borderRadius: '10px'
    },
    messageTextAndDate: {
        display: 'flex',
        flexDirection: 'column',
        flex: 3
    }
}));

const DialogDetailTask = ({
    taskSelected,
    handlePrintDoc,
    handleClose,
    addObservation,
    deleteObservation,
    addFile,
    deletePhoto,
    sendInforme,
    handleSendReportByEmail,
    handleCreateInvoice,
    handleShowPDFSign,
    handleSendInvoiceByEmail,
    handleSendProformaByEmail,
    handleSendInvoiceWhatsapp,
    handleSendProformaWhatsapp,
    handleCreateProforma,
    handleCopyFacturaLink,
    handleCopyProformaLink,
    handleCopyInformeLink
}) => {
    const classes = useStyles();

    const [refill, setRefill] = useState(70)
    const [manPower, setManPower] = useState(30)
    const [openTests, setOpenTests] = useState(false)
    const [testsInitialResults, setTestsInitialResults] = useState(null)

    useEffect(() => {
        setRefill(taskSelected.detail.refill)
        setManPower(taskSelected.detail.manPower)
    }, [taskSelected.detail.refill, taskSelected.detail.manPower])

    const handleChangeRefill = event => {
        const value = event.target.value
        const refill = value > 100 ? 100 : value
        const manPower = 100 - refill || 0

        setRefill(refill)
        setManPower(manPower)

        updateParamsBudgetUseCase(taskSelected, refill ? parseInt(refill) : refill, manPower ? parseInt(manPower) : manPower)
    }

    const handleChangeManPower = event => {
        const value = event.target.value
        const manPower = value > 100 ? 100 : value
        const refill = 100 - manPower || 0

        setRefill(refill)
        setManPower(manPower)

        updateParamsBudgetUseCase(taskSelected, refill ? parseInt(refill) : refill, manPower ? parseInt(manPower) : manPower)
    }

    const defaultParams = () => {
        setRefill(70)
        setManPower(30)
        updateParamsBudgetUseCase(taskSelected.data.id, 70, 30)
    }

    const handleAddFile = file => {
        addFile(file);
    }

    return (
        <Grid container style={{ height: '100%' }}>
            <IconButton onClick={handleClose} aria-label="Close" className={classes.closeButton}>
                <CloseIcon />
            </IconButton>
            <Grid item xs={12} sm={12} md={4} className={classes.columns}>
                <Grid item className={classes.block}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={2}>

                                {/* FACTURAS */}
                                <Grid item xs={12} md={4}>
                                    <div style={{
                                        background: "#f2f2f2",
                                        borderRadius: 8,
                                        padding: 12,
                                    }}>
                                        <Typography 
                                            variant="subtitle1" 
                                            style={{ 
                                                fontWeight: 600, 
                                                marginBottom: 12, 
                                                textAlign: "center"
                                            }}
                                        >
                                            Facturas
                                        </Typography>

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                            <Button
                                                className={`${classes.chip} ${classes.docButton}`}
                                                color="primary"
                                                variant="contained"
                                                onClick={handleCreateInvoice}
                                            >
                                                Crear factura
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.greenButton} ${classes.docButton}`}
                                                variant="contained"
                                                onClick={handleSendInvoiceWhatsapp}
                                            >
                                                Enviar por WhatsApp
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.docButton} ${classes.emailButton}`}
                                                variant="contained"
                                                onClick={() => handleSendInvoiceByEmail && handleSendInvoiceByEmail()}
                                            >
                                                Enviar por Email
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.docButton} ${classes.copyButton}`}
                                                variant="contained"
                                                onClick={handleCopyFacturaLink}
                                            >
                                                Copiar enlace
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>

                                {/* PROFORMAS */}
                                <Grid item xs={12} md={4}>
                                    <div style={{
                                        background: "#f2f2f2",
                                        borderRadius: 8,
                                        padding: 12,
                                    }}>
                                        <Typography 
                                            variant="subtitle1" 
                                            style={{
                                                fontWeight: 600,
                                                marginBottom: 12,
                                                textAlign: "center"
                                            }}
                                        >
                                            Proformas
                                        </Typography>

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                            <Button
                                                className={`${classes.chip} ${classes.docButton}`}
                                                color="primary"
                                                variant="contained"
                                                onClick={handleCreateProforma}
                                            >
                                                Crear proforma
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.greenButton} ${classes.docButton}`}
                                                variant="contained"
                                                onClick={handleSendProformaWhatsapp}
                                            >
                                                Enviar por WhatsApp
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.docButton} ${classes.emailButton}`}
                                                variant="contained"
                                                onClick={() => handleSendProformaByEmail && handleSendProformaByEmail()}
                                            >
                                                Enviar por Email
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.docButton} ${classes.copyButton}`}
                                                variant="contained"
                                                onClick={handleCopyProformaLink}
                                            >
                                                Copiar enlace
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>

                                {/* INFORMES */}
                                <Grid item xs={12} md={4}>
                                    <div style={{
                                        background: "#f2f2f2",
                                        borderRadius: 8,
                                        padding: 12,
                                    }}>
                                        <Typography 
                                            variant="subtitle1" 
                                            style={{
                                                fontWeight: 600,
                                                marginBottom: 12,
                                                textAlign: "center"
                                            }}
                                        >
                                            Informes
                                        </Typography>

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                            <Button
                                                className={`${classes.chip} ${classes.docButton}`}
                                                color="primary"
                                                variant="contained"
                                                onClick={handleShowPDFSign}
                                            >
                                                Ver informe
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.greenButton} ${classes.docButton}`}
                                                variant="contained"
                                                onClick={sendInforme}
                                            >
                                                Enviar por WhatsApp
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.docButton} ${classes.emailButton}`}
                                                variant="contained"
                                                onClick={handleSendReportByEmail}
                                            >
                                                Enviar por Email
                                            </Button>

                                            <Button
                                                className={`${classes.chip} ${classes.docButton} ${classes.copyButton}`}
                                                variant="contained"
                                                onClick={handleCopyInformeLink}
                                            >
                                                Copiar enlace
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                            {/* TESTS */}
                            <Grid item xs={12}>
                                <div style={{ background: "#e8f5e9", borderRadius: 8, padding: 12, marginTop: 16 }}>
                                    <Typography
                                        variant="subtitle1"
                                        style={{ fontWeight: 600, marginBottom: 12, textAlign: "center", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
                                    >
                                        <AssignmentTurnedInIcon style={{ fontSize: 18 }} />
                                        Test reparación
                                    </Typography>
                                    {(() => {
                                        const hasResults = taskSelected.data.testResults && Object.keys(taskSelected.data.testResults).length > 0
                                        return (
                                            <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
                                                {hasResults && (
                                                    <Button
                                                        className={`${classes.chip} ${classes.docButton}`}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => { setTestsInitialResults(taskSelected.data.testResults); setOpenTests(true) }}
                                                    >
                                                        Ver resultado
                                                    </Button>
                                                )}
                                                <Button
                                                    className={`${classes.chip} ${classes.docButton}`}
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={() => { setTestsInitialResults(null); setOpenTests(true) }}
                                                >
                                                    Realizar test
                                                </Button>
                                            </div>
                                        )
                                    })()}
                                </div>
                            </Grid>

                        </CardContent>
                    </Card>
                    <TestsDialog
                        open={openTests}
                        onClose={() => setOpenTests(false)}
                        ticketId={taskSelected.data.id}
                        initialResults={testsInitialResults}
                        collection="tasks"
                    />
                </Grid>
                <Grid item className={classes.block}>
                    <Card>
                        <CardHeader title="Porcentajes presupuesto" />
                        <Divider className={classes.divider}></Divider>
                        <CardContent style={{ display: "flex" }}>
                            <TextField
                                label="Recambios"
                                variant="outlined"
                                value={refill}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">%</InputAdornment>,
                                }}
                                style={{ paddingRight: "10px", flex: 1 }}
                                onChange={handleChangeRefill}
                                defaultValue={70}
                            />
                            <TextField
                                label="Mano de obra"
                                variant="outlined"
                                value={manPower}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">%</InputAdornment>,
                                }}
                                style={{ paddingRight: "10px", flex: 1 }}
                                onChange={handleChangeManPower}
                                defaultValue={30}
                            />
                            <Button variant="contained" style={{ backgroundColor: "red", color: "white" }} onClick={defaultParams}>
                                Restablecer
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item className={classes.block}>
                    <CardTextChat
                        title="Observaciones"
                        observations={taskSelected.detail.observations || []}
                        addObservation={addObservation}
                        deleteObservation={deleteObservation}
                        messageType="observations"
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4} className={classes.columns}>
                <Grid item className={classes.block}>
                    <CardTextChat
                        title="Sintomas averia"
                        observations={taskSelected.detail.failures || []}
                        addObservation={addObservation}
                        deleteObservation={deleteObservation}
                        messageType="failures"
                    />
                </Grid>
                <Grid item className={classes.block}>
                    <CardTextChat
                        title="Diagnóstico"
                        observations={taskSelected.detail.works || []}
                        addObservation={addObservation}
                        deleteObservation={deleteObservation}
                        messageType="works"
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
                <Grid item className={classes.block}>
                    <CardTextChat
                        title="Resolución"
                        observations={taskSelected.detail.estimationWork || []}
                        addObservation={addObservation}
                        deleteObservation={deleteObservation}
                        messageType="estimationWork"
                    />
                </Grid>
                <Grid item className={classes.block}>
                    <PhotoGalleryCard
                        images={taskSelected.detail.images}
                        addFile={handleAddFile}
                        deletePhoto={deletePhoto}
                    />
                </Grid>
            </Grid>

        </Grid>
    )
};

export default DialogDetailTask;